import React, { useEffect } from 'react';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import { Slider, Box, Typography } from '@mui/material';

export const TextFormField = ({ field, form, sliderValue }) => {
    const errorText = form.touched[field.name] && form.errors[field.name];
    return (
        <FormControl fullWidth error={Boolean(errorText)} style={{ display: 'none' }}>
            <TextField
                {...field}
                id={field.name}
                error={Boolean(errorText)}
                value={sliderValue.join(' - ')}
                helperText={errorText}
                InputLabelProps={{ shrink: true }}
            />
        </FormControl>
    );
};

const StyledSlider = ({ onValueChange, value, initialValue, finalValue, label }) => {
    const handleChange = (event, newValue) => {
        onValueChange(newValue);
    };

    return (
        <Box>
            <Typography variant='body2'>{label}</Typography>
            <Slider
                value={value}
                min={initialValue}
                max={finalValue}
                onChange={handleChange}
                valueLabelDisplay="off"
                sx={{
                    color: '#DC143C',
                    '& .MuiSlider-thumb': {
                        color: '#DC143C',
                    },
                    '& .MuiSlider-track': {
                        border: 'none',
                    },
                    '& .MuiSlider-rail': {
                        color: '#d9d9d9',
                    },
                    height: "7px",
                }}
            />
            <Box display="flex" justifyContent="space-between" mt={1}>
                <Typography variant='body2'>{value[0]}</Typography>
                <Typography variant='body2'>{value[1]}</Typography>
            </Box>
        </Box>
    );
};

const FormWithSlider = ({ field, form, initialValue, finalValue, label }) => {
    const [sliderValue, setSliderValue] = React.useState(form.values[field.name] || [initialValue, finalValue]);
    
    useEffect(() => {
        if (form.values[field.name]) {
            setSliderValue(form.values[field.name]);
        }
    }, [form.values[field.name]]);
    
    const handleSliderChange = (value) => {
        setSliderValue(value);
        form.setFieldValue(field.name, value);
    };

    return (
        <Box>
            <StyledSlider
                onValueChange={handleSliderChange}
                value={sliderValue}
                initialValue={initialValue}
                finalValue={finalValue}
                label={label}
            />
            <TextFormField
                field={field}
                form={form}
                sliderValue={sliderValue}
            />
        </Box>
    );
};

export default FormWithSlider;
